import React from 'react';

export default function HelloWorld() {
    return <div>Hello World</div>;
}
